export async function runSingleFlight(owner, flagName, operation) {
  if (owner[flagName]) return false;

  owner[flagName] = true;
  try {
    await operation();
    return true;
  } finally {
    owner[flagName] = false;
  }
}

export function currentAdmissionPoll(owner, requestedAdmissionId, requestedGeneration) {
  return owner.state === "waiting" &&
    owner.admissionId === requestedAdmissionId &&
    owner._admissionPollGeneration === requestedGeneration;
}

export function completeAdmissionCancellation(response, cleanup) {
  if (!response.ok) throw new Error("Nie udało się anulować zgłoszenia. Spróbuj ponownie.");

  cleanup();
}

export function terminalAdmissionMessage(status) {
  if (status === "rejected") return "Egzaminator nie zaakceptował tego zgłoszenia.";
  if (status === "expired") return "Zgłoszenie wygasło.";
  return "Zgłoszenie nie zostało przyjęte.";
}
